var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "notifications", attrs: { fluid: "" } },
    [
      _c("div", { staticClass: "my-6" }, [
        _c("span", [_c("h2", [_vm._v("Notifications")])]),
      ]),
      _c(
        "v-card",
        {
          staticClass: "notification-card mx-auto mb-6",
          attrs: { elevation: "2" },
        },
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-toolbar",
                { attrs: { flat: "" } },
                [
                  _c(
                    "v-toolbar-title",
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "align-center",
                          attrs: { left: "", color: "black" },
                        },
                        [_vm._v(" mdi-send-outline ")]
                      ),
                      _vm._v(" Send Notification "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-container",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.valid,
                        callback: function ($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid",
                      },
                    },
                    [
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Title",
                                  dense: "",
                                  required: "",
                                  rules: _vm.titleRules,
                                  "validate-on-blur": "",
                                  outlined: "",
                                  "hide-details": "auto",
                                  counter: "100",
                                },
                                model: {
                                  value: _vm.notification.title,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.notification, "title", $$v)
                                  },
                                  expression: "notification.title",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  label: "Message",
                                  dense: "",
                                  required: "",
                                  rules: _vm.messageRules,
                                  "validate-on-blur": "",
                                  outlined: "",
                                  "hide-details": "auto",
                                  counter: "500",
                                  rows: "6",
                                  "auto-grow": "",
                                },
                                model: {
                                  value: _vm.notification.message,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.notification, "message", $$v)
                                  },
                                  expression: "notification.message",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  label: "Store Groups",
                                  items: _vm.storeGroups,
                                  rules: _vm.storeGroupRules,
                                  loading: _vm.loadingStoreGroups,
                                  disabled: _vm.loadingStoreGroups,
                                  "item-text": "text",
                                  "item-value": "value",
                                  "return-object": "",
                                  dense: "",
                                  required: "",
                                  outlined: "",
                                  "hide-details": "auto",
                                  multiple: "",
                                  "small-chips": "",
                                  "deletable-chips": "",
                                },
                                on: { change: _vm.onStoreGroupChange },
                                scopedSlots: _vm._u([
                                  {
                                    key: "prepend-item",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-list-item",
                                          {
                                            attrs: { ripple: "" },
                                            on: { click: _vm.toggleSelectAll },
                                          },
                                          [
                                            _c(
                                              "v-list-item-action",
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      color:
                                                        _vm.selectedStoreGroups
                                                          .length > 0
                                                          ? "primary"
                                                          : "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.selectAllIcon
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v("Select All"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("v-divider", {
                                          staticClass: "mt-2",
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "selection",
                                    fn: function ({ item, index }) {
                                      return [
                                        _c(
                                          "v-chip",
                                          {
                                            attrs: { small: "", close: "" },
                                            on: {
                                              "click:close": function ($event) {
                                                return _vm.removeStoreGroup(
                                                  index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.text) + " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.selectedStoreGroups,
                                  callback: function ($$v) {
                                    _vm.selectedStoreGroups = $$v
                                  },
                                  expression: "selectedStoreGroups",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mt-4", attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    disabled: !_vm.valid || _vm.loading,
                                    loading: _vm.loading,
                                  },
                                  on: { click: _vm.validateAndSubmit },
                                },
                                [_vm._v(" Send Notification ")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ml-2",
                                  attrs: { text: "", disabled: _vm.loading },
                                  on: { click: _vm.resetForm },
                                },
                                [_vm._v(" Reset ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px" },
          model: {
            value: _vm.confirmDialog,
            callback: function ($$v) {
              _vm.confirmDialog = $$v
            },
            expression: "confirmDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("v-icon", { attrs: { left: "", color: "warning" } }, [
                    _vm._v("mdi-alert-circle-outline"),
                  ]),
                  _vm._v(" Confirm Send Notification "),
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c("div", { staticClass: "text-body-1 mb-2" }, [
                    _vm._v(
                      " Are you sure you want to send this notification? "
                    ),
                  ]),
                  _c("v-divider", { staticClass: "my-3" }),
                  _c("div", { staticClass: "mb-2" }, [
                    _c("strong", [_vm._v("Title:")]),
                    _vm._v(" " + _vm._s(_vm.notification.title) + " "),
                  ]),
                  _c("div", { staticClass: "mb-2" }, [
                    _c("strong", [_vm._v("Message:")]),
                    _vm._v(" " + _vm._s(_vm.notification.message) + " "),
                  ]),
                  _c("div", [
                    _c("strong", [_vm._v("Recipients:")]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.selectedStoreGroups.length) +
                        " store group(s) "
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.confirmDialog = false
                        },
                      },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", loading: _vm.loading },
                      on: { click: _vm.confirmSend },
                    },
                    [_vm._v(" Send ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.viewDialog,
            callback: function ($$v) {
              _vm.viewDialog = $$v
            },
            expression: "viewDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("span", { staticClass: "text-h5" }, [
                    _vm._v("Notification Details"),
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          _vm.viewDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _vm.selectedNotification
                ? _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-subtitle-2 grey--text",
                                    },
                                    [_vm._v("Status")]
                                  ),
                                  _c(
                                    "v-chip",
                                    {
                                      staticClass: "mt-1",
                                      attrs: {
                                        color: _vm.getStatusColor(
                                          _vm.selectedNotification.status
                                        ),
                                        dark: "",
                                        small: "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.selectedNotification.status
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "mt-4", attrs: { cols: "12" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-subtitle-2 grey--text",
                                    },
                                    [_vm._v("Title")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "text-body-1 mt-1" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.selectedNotification.title
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "v-col",
                                { staticClass: "mt-4", attrs: { cols: "12" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-subtitle-2 grey--text",
                                    },
                                    [_vm._v("Message")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-body-1 mt-1",
                                      staticStyle: {
                                        "white-space": "pre-wrap",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.selectedNotification.message
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "mt-4",
                                  attrs: { cols: "12", md: "6" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-subtitle-2 grey--text",
                                    },
                                    [_vm._v("Created")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "text-body-2 mt-1" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatDateTime(
                                              _vm.selectedNotification
                                                .createdDate
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm.selectedNotification.sentDate
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "mt-4",
                                      attrs: { cols: "12", md: "6" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-subtitle-2 grey--text",
                                        },
                                        [_vm._v("Sent")]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "text-body-2 mt-1" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatDateTime(
                                                  _vm.selectedNotification
                                                    .sentDate
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "v-col",
                                {
                                  staticClass: "mt-4",
                                  attrs: { cols: "12", md: "6" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-subtitle-2 grey--text",
                                    },
                                    [_vm._v("Recipients")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "text-body-2 mt-1" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.selectedNotification.recipients
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { color: _vm.snackbarColor, timeout: 3000, top: "" },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { text: "" },
                        on: {
                          click: function ($event) {
                            _vm.snackbar = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Close ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [_vm._v(" " + _vm._s(_vm.snackbarText) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }